import { render, staticRenderFns } from "./ProductsVue.vue?vue&type=template&id=716c41b8&scoped=true&"
import script from "./ProductsVue.vue?vue&type=script&lang=js&"
export * from "./ProductsVue.vue?vue&type=script&lang=js&"
import style0 from "./ProductsVue.vue?vue&type=style&index=0&id=716c41b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716c41b8",
  null
  
)

export default component.exports